
































































import Vue from "vue";
import { mapActions, mapMutations } from "vuex";
import * as ad from "@/store/modules/DevicesModule/actions";
import * as m from "@/store/modules/DevicesModule/mutations";
import * as routes from "@/router/routes";

// Vue components
import AppPage from "@/components/AppPage.vue";
import BranchCard from "./BranchCard.vue";
import AddNewBranchDialog from "./AddNewBranchDialog.vue";

// Model
import { GetBranchesResData } from "@/model/communication/branch/GetBranchesResData";
import { GetBranchesCommand } from "@/model/communication/branch/GetBranchesCommand";
import { DeleteBranchCommand } from "@/model/communication/branch/DeleteBranchCommand";
import { EditBranchCommand } from "@/model/communication/branch/EditBranchCommand";
import { CreateBranchCommand } from "@/model/communication/branch/CreateBranchCommand";
import { GetInstallationsCountByBranchCommand } from "@/model/communication/branch/GetInstallationsCountByBranchCommand";
import { AnyStatisticsWithBranchIdCommand, AnyStatisticsWithBranchIdResData } from "@/model/communication/fitnessStatistics/AnyStatisticsWithBranchIdCommand";

import { GetBranchesReqData } from "@/model/communication/branch/GetBranchesReqData";
import { ApiResponseStatusEnum } from "@/model/communication/ApiResponseStatusEnum";
import { GetInstallationsCountByBranchResData } from "@/model/communication/branch/GetInstallationsCountByBranchResData";
import { EditBranchInstallationsReqData } from "@/model/communication/branch/EditBranchInstallationsReqData";
import { EditBranchInstallationsCommand } from "@/model/communication/branch/EditBranchInstallationsCommand";

export default Vue.extend({
    components: {
        AppPage,
        BranchCard,
        AddNewBranchDialog,
    },
    data() {
        return {
            routes,
            loading: false,
            loadingAnyStatisticsWithBranchId: false,
            loadingInstallationsCountByBranch: false,
            loadingEditInstallationsBranch: false,
            installationsCountByBranch: null,
            addNewBranchDialog: false,
            branches: [],
            showDeleteConfirmationDialog: false,
            selectedBranchIdForDelete: null,
            search: "",
            errorMessage: "",
            error: false,
        };
    },
    computed: {
        menuRoutes() {
            return this.$store.getters.availableMenu;
        },

        styleProps() {
            let found = false;
            let resultObj = { icon: null, title: null, color: null };

            let findIconColorAndTitle: Function = (node: any) => {
                if (!found) {
                    if (node.children && node.children.length > 0) {
                        node.children.forEach((child) => {
                            findIconColorAndTitle(child);
                        });
                    } else if (node.path == this.routes.BranchesManagement) {
                        resultObj.icon = node.icon;
                        resultObj.title = this.$t(node.name_i18n);
                        resultObj.color = node.color;
                        found = true;
                    }
                }
            };

            this.menuRoutes.forEach((route) => {
                findIconColorAndTitle(route);
            });

            return resultObj;
        },

        icon() {
            return this.styleProps.icon ? this.styleProps.icon : "";
        },

        title() {
            return this.styleProps.title ? this.styleProps.title : "";
        },

        color() {
            return this.styleProps.color ? this.styleProps.color : "";
        },

        branchesWithInstallationsCount() {
            let res = [];

            if (Array.isArray(this.branches) && this.branches.length) {
                this.branches.forEach((branch) => {
                    let currentBranch = { ...branch };

                    if (this.installationsCountByBranch != null && this.installationsCountByBranch.has(currentBranch.id)) {
                        currentBranch.visibleInstallationsCount = this.installationsCountByBranch.get(currentBranch.id).visibleInstallationsCount;
                        currentBranch.globalInstallationsCount = this.installationsCountByBranch.get(currentBranch.id).globalInstallationsCount;
                    } else {
                        currentBranch.visibleInstallationsCount = 0;
                        currentBranch.globalInstallationsCount = 0;
                    }

                    res.push(currentBranch);
                });
            }

            return res;
        },
    },
    watch: {
        showDeleteConfirmationDialog(newValue) {
            if (!newValue) this.selectedBranchIdForDelete = null;
        },
    },
    methods: {
        ...mapActions([ad.FETCH_ALL_DEVICE_TREE]),
        ...mapMutations([m.SET_DEVICE_TREE_CONTENT]),

        async CRUD(branchId, branch, request: "C" | "R" | "U" | "D") {
            if (!this.loading && !this.loadingAnyStatisticsWithBranchId && !this.loadingInstallationsCountByBranch) {
                try {
                    this.error = false;
                    this.loading = true;
                    let res: GetBranchesResData;
                    switch (request) {
                        case "C":
                            await this.createBranch(branch);
                            break;
                        case "R":
                            this.getBranches();
                            break;
                        case "U":
                            res = await new EditBranchCommand(branch).execute();
                            if (res.responseStatus == ApiResponseStatusEnum.Success) this.branches = res.availableBranches;
                            else console.error("cannot edit this branch: ", branch);
                            break;
                        case "D":
                            res = await new DeleteBranchCommand(branchId).execute();
                            if (res.responseStatus == ApiResponseStatusEnum.Success) this.branches = res.availableBranches;
                            else console.error("cannot delete this branch: ", branchId);
                            break;
                    }
                    this.loading = false;
                } catch (e) {
                    console.error("Server error, request: ", request, " branchId: ", branchId, " branch: ", branch);
                    this.loading = false;
                }
            }
        },
        async createBranch(branch) {
            let res: GetBranchesResData = await new CreateBranchCommand(branch.branch, branch.createFolder).execute();
            if (res.responseStatus == ApiResponseStatusEnum.Success && res.responseString != "GenericError") {
                this.branches = res.availableBranches;
                if (branch.createFolder) {
                    await new Promise((r) => setTimeout(r, 1000));
                    this[m.SET_DEVICE_TREE_CONTENT]({ node: null, content: [] });
                    await this[ad.FETCH_ALL_DEVICE_TREE]();
                }
            } else {
                this.error = true;
                if (res.message != null && res.message != "" && res.message != "Server error, ServerError") this.errorMessage = res.message;
                else this.errorMessage = this.$t("branchesManagement.duplicated");
            }
        },
        async getBranches() {
            let res: GetBranchesResData = await new GetBranchesCommand(new GetBranchesReqData(true, false)).execute();
            if (res.responseStatus == ApiResponseStatusEnum.Success) this.branches = res.availableBranches;
            else console.error("cannot fetch available branches");
        },
        async deleteBranch(branchId) {
            if (!this.loading && !this.loadingAnyStatisticsWithBranchId) {
                try {
                    this.loadingAnyStatisticsWithBranchId = true;
                    let res: AnyStatisticsWithBranchIdResData = await new AnyStatisticsWithBranchIdCommand(branchId).execute();
                    this.loadingAnyStatisticsWithBranchId = false;

                    if (res.responseStatus == ApiResponseStatusEnum.Success) {
                        // questo branch è associato a delle statistiche fitness, esse verranno eliminate, continuare?
                        if (res.result) {
                            console.warn("questo branch è associato a delle statistiche fitness, esse verranno eliminate, continuare?");
                            this.selectedBranchIdForDelete = branchId;
                            this.showDeleteConfirmationDialog = true;
                        } else this.CRUD(branchId, null, "D");
                    } else console.error("cannot delete this branch: ", branchId);
                } catch (e) {
                    console.error("cannot delete this branch: ", branchId);
                    this.loadingAnyStatisticsWithBranchId = false;
                }
            }
        },

        async getInstallationsCountByBranch() {
            try {
                this.loadingInstallationsCountByBranch = true;
                let res: GetInstallationsCountByBranchResData = await new GetInstallationsCountByBranchCommand().execute();
                this.loadingInstallationsCountByBranch = false;

                if (res.responseStatus == ApiResponseStatusEnum.Success) {
                    this.installationsCountByBranch = res.installationsCountByBranch;
                } else console.error("Error executing GetInstallationsCountByBranchCommand");
            } catch (e) {
                console.error("Error executing GetInstallationsCountByBranchCommand");
                this.loadingInstallationsCountByBranch = false;
            }
        },

        async editInstallationsBranch(request) {
            try {
                this.loadingEditInstallationsBranch = true;
                let res = await new EditBranchInstallationsCommand(request as EditBranchInstallationsReqData).execute();
                this.loadingEditInstallationsBranch = false;

                if (res.responseStatus == ApiResponseStatusEnum.Success) {
                    await this.CRUD(null, null, "R");
                    this.getInstallationsCountByBranch();
                } else console.error("Error executing EditBranchInstallationsCommand");
            } catch (e) {
                console.error("Error executing EditBranchInstallationsCommand");
                this.loadingEditInstallationsBranch = false;
            }
        },
    },
    async mounted() {
        this.CRUD(null, null, "R");
        await this.getInstallationsCountByBranch();
    },
});
